import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { useClient } from '../../context/ClientContext';
import './EmailForm.css';

const EmailForm: React.FC = () => {
  const { selectedClientId } = useClient();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('Your Backyard Renovation.');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const payload: Record<string, string | number> = {
        first_name: firstName,
        last_name: lastName,
        email,
        subject: subject.trim() || 'Your Backyard Renovation.',
      };
      if (selectedClientId != null) {
        payload.client_id = selectedClientId;
      }
      await api.post('/email/send-customer-email', payload);
      setSuccess('Email sent successfully!');
      setFirstName('');
      setLastName('');
      setEmail('');
      setSubject('Your Backyard Renovation.');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to send email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="email-form-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap', marginBottom: '0.5rem' }}>
        <h3 style={{ margin: 0 }}>Send Email</h3>
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          <Link to="/dashboard/email/upload-csv" className="btn btn-secondary-orange" style={{ textDecoration: 'none' }}>
            Upload CSV
          </Link>
          <Link to="/dashboard/sent-review-emails" className="btn btn-secondary-orange" style={{ textDecoration: 'none' }}>
            View Sent Emails
          </Link>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="email-form">
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <div className="form-group">
          <label htmlFor="subject">Subject</label>
          <input
            type="text"
            id="subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
            placeholder="Your Backyard Renovation."
            maxLength={255}
          />
        </div>

        <div className="form-group">
          <label htmlFor="first_name">First Name</label>
          <input
            type="text"
            id="first_name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
            placeholder="Enter first name"
          />
        </div>

        <div className="form-group">
          <label htmlFor="last_name">Last Name</label>
          <input
            type="text"
            id="last_name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
            placeholder="Enter last name"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="recipient@example.com"
          />
        </div>

        <button type="submit" disabled={loading} className="btn btn-primary btn-block">
          {loading ? 'Sending...' : 'Send Email'}
        </button>
      </form>
    </div>
  );
};

export default EmailForm;
